export default () => /iPhone|iPad|iPod/i.test(navigator.userAgent)
